/**
 * Project Andromeda
 * Denis Callinan
 * May 18th, 2020
 * Comment.js - React Component for small text (i.e copyright)
 */

 // Dependencies
 import React from 'react';

 export default class Footer extends React.Component {
    render() {
        const fbLink = "https://www.facebook.com/drcall4/";
        const ghLink = "https://github.com/drcall";
        const liLink = "https://www.linkedin.com/in/drcall";
        return(
            <footer className = "footer">
                <p className = "footerContent">© 2020 Denis Callinan</p>
                <p className = "footerContent">
                    <a className = "footerContent" href = {liLink}>LinkedIn</a> / <a className = "footerContent" href = {fbLink}>Facebook</a> / <a className = "footerContent" href = {ghLink}>GitHub</a>
                </p>
            </footer>
        );
    }
 }